<template>
    <v-app>

        <v-content>

            <template v-if="loading">
                <v-progress-circular indeterminate
                                     color="primary"
                                     :size="40"
                                     width="2"></v-progress-circular>
            </template>

            <template v-else-if="atlasData">

                <v-container :style="appStyle" fluid height-100 class="pa-0" :key="key">

                    <v-container fluid class="atlas-title-bg pa-0">

                        <AtlasNav />

                        <v-container class="landing-description container-wrapper atlas-title">

                            <v-row class="text-center">

                                <v-col cols="12" class="d-flex justify-center">

                                    <h1 v-html="atlasData['title']" class="intro-title mb-5"></h1>
                                    <p>
                                        <EditButton :e="{
											value: atlasData['title'],
											key: 'title',
											title: 'Pavadinimas',
											atlasId: atlasId,
											callback: getAtlasSummary,
										}"
                                                    v-if="isMineAtlas(atlasData)"
                                                    class="primary--text" />
                                    </p>

                                </v-col>

                            </v-row>
                            <v-row>

                                <v-col cols="12" class="d-flex justify-center">

                                    <h2 v-html="atlasData['shortDescription']" class="intro-subtitle mb-5 text-center"></h2>
                                    <EditButton :e="{
											value: atlasData['shortDescription'],
											key: 'shortDescription',
											title: 'Trumpas aprašymas',
											atlasId: atlasId,
											callback: getAtlasSummary
										}"
                                                v-if="isMineAtlas(atlasData)"
                                                class="primary--text" />

                                </v-col>

                            </v-row>

                            <v-row class="text-center">

                                <v-col cols="12">

                                    <router-link v-bind:to="'/atlas/' + atlasId + '/view'"
                                                 class="link mr-2"
                                                 v-if="atlasData['atlasType'] == 'interactive'">
                                        <v-btn large rounded color="primary" dark>
                                            Peržiūrėti
                                        </v-btn>
                                    </router-link>

                                    <router-link v-bind:to="'/atlas/' + atlasId + '/edit'"
                                                 class="link mr-2"
                                                 v-if="atlasData['role'] == 'owner' || atlasData['role'] == 'editor'">
                                        <v-btn large rounded>
                                            Redaguoti turinį
                                        </v-btn>
                                    </router-link>

                                    <v-btn large
                                           rounded
                                           color="primary"
                                           dark
                                           v-if="atlasData['atlasType'] == 'printable' && atlasData['status'] == '1'"
                                           v-on:click="downloadAtlas">
                                        Atsisiųsti atlasą
                                    </v-btn>

                                </v-col>

                            </v-row>

                            <v-row class="atlas-title-upload">

                                <v-col cols="12" class="">

                                    <template v-if="isMineAtlas(atlasData)">

                                        <template v-if="atlasImage">
                                            <v-btn v-on:click="deleteImg"
                                                   :loading="imgDeleteInAction"
                                                   small
                                                   class="mb-6"
                                                   outlined
                                                   rounded
                                                   color="white">
                                                Šalinti atlaso foninį piešinuką/nuotrauką
                                            </v-btn>
                                        </template>
                                        <template v-else>
                                            <v-file-input label="Foninis piešinukas/nuotrauka"
                                                          v-model="img"
                                                          accept="image/jpeg, image/png"></v-file-input>
                                            <v-btn v-on:click="uploadImg"
                                                   :loading="imgUploadInAction"
                                                   small
                                                   class="mb-6"
                                                   v-if="img"
                                                   outlined
                                                   rounded
                                                   color="primary">
                                                Įkelti
                                            </v-btn>
                                        </template>

                                    </template>

                                </v-col>

                            </v-row>

                        </v-container>

                    </v-container>

                </v-container>

                <v-container class="landing-description container-wrapper">

                    <v-row class="pt-6 text-sm-left text-center">

                        <v-col cols="12">

                            <div class="d-flex">
                                <div v-html="atlasData['description']" class="flex-grow-1"></div>
                                <EditButton :e="{
										rich: true,
										value: atlasData['description'],
										key: 'description',
										title: 'Aprašymas',
										atlasId: atlasId,
										callback: getAtlasSummary
									}"
                                            v-if="isMineAtlas(atlasData)"
                                            class="primary--text" />
                            </div>

                        </v-col>

                    </v-row>

                    <v-row class="pt-6">

                        <v-col cols="12">

                            <div class="d-flex">
                                <span class="pr-2">Raktažodžiai:</span>
                                <div v-html="atlasData['keywords']" class="flex-grow-1"></div>
                                <EditButton :e="{
										value: atlasData['keywords'],
										key: 'keywords',
										title: 'Raktažodžiai',
										atlasId: atlasId,
										callback: getAtlasSummary
									}"
                                            v-if="isMineAtlas(atlasData)"
                                            class="primary--text" />
                            </div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12">

                            <div class="d-flex">
                                <span class="pr-2">Šaltiniai:</span>
                                <div v-html="atlasData['sources']" class="flex-grow-1"></div>
                                <EditButton :e="{
										value: atlasData['sources'],
										key: 'sources',
										title: 'Šaltiniai',
										atlasId: atlasId,
										callback: getAtlasSummary
									}"
                                            v-if="isMineAtlas(atlasData)"
                                            class="primary--text" />
                            </div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12">

                            <div class="d-flex">
                                <span class="pr-2">Autorių teisės:</span>
                                <div v-html="atlasData['copyright']" class="flex-grow-1"></div>
                                <EditButton :e="{
										value: atlasData['copyright'],
										key: 'copyright',
										title: 'Autorių teisės',
										atlasId: atlasId,
										callback: getAtlasSummary
									}"
                                            v-if="isMineAtlas(atlasData)"
                                            class="primary--text" />
                            </div>

                        </v-col>

                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <div class="d-flex">
                                <span class="pr-2">Atlaso dydis:</span>
                                <div v-html="atlasData['atlasSize'] + ' MB'" class="flex-grow-1"></div>
                            </div>

                        </v-col>
                    </v-row>

                    <v-row class="pt-6">

                        <v-col cols="12">

                            <template v-if="isMineAtlas(atlasData)">

                                <v-btn v-on:click="deleteAtlas"
                                       :loading="deleteInAction"
                                       small
                                       outlined
                                       rounded
                                       color="error">
                                    Ištrinti atlasą
                                </v-btn>

                            </template>

                        </v-col>

                    </v-row>

                </v-container>

            </template>

            <template v-else-if="loadingError">
                <div>Atlaso informacija nepasiekiama. Pabandykite dar kartą. Jeigu klaida kartojasi, informuokite paslaugos administratorius pagalba@geoportal.lt</div>
            </template>

            <AtlasSummaryForm />
            <AttributeEditForm />
            <CommonComponents />
        </v-content>

        <v-footer class="white">
            <Footer />
        </v-footer>

    </v-app>
</template>

<script>
    import AtlasNav from "../header/AtlasNav";
    import Footer from "../footer/FooterTitle";
    import CommonHelper from "../helpers/CommonHelper";
    import AtlasHelper from "../helpers/AtlasHelper";
    import AtlasSummaryForm from "../atlas/AtlasSummaryForm";
    import AttributeEditForm from "../atlas/AttributeEditForm";
    import CommonComponents from "../CommonComponents";
    import EditButton from "../EditButton";

    export default {
        components: {
            AtlasNav,
            Footer,
            AtlasSummaryForm,
            CommonComponents,
            EditButton,
            AttributeEditForm
        },
        data: function () {
            var data = {
                drawer: false,
                loading: true,
                loadingError: false,
                atlasId: null,
                atlasData: null,
                deleteInAction: null,
                img: null,
                imgUploadInAction: false,
                imgDeleteInAction: false,
                atlasImage: null,
                appStyle: null,
                key: 0
            };
            return data;
        },
        created: function () {
            this.getAtlasSummary();
        },
        methods: {
            showAtlasSummaryForm: function () {
                this.$vBus.$emit("show-atlas-summary-form", {
                    id: this.atlasId,
                    data: this.atlasData,
                    callback: this.getAtlasSummary
                });
            },
            getAtlasSummary: function () {
                var path = this.$router.history.current.path,
                    atlasPathData = CommonHelper.getAtlasPathData(path);
                if (atlasPathData) {
                    this.loading = true;
                    this.atlasId = atlasPathData[0];
                    this.getAtlasData();
                } else {
                    // Taip net teoriškai nelabai galėtų būti...
                }
            },
            deleteAtlas: function () {
                var positiveCallback = function () {
                    this.deleteInAction = true;
                    AtlasHelper.deleteAtlas(this.atlasId).then(function () {
                        this.deleteInAction = false;
                        this.$router.push("/my-content");
                    }.bind(this), function () {
                        this.$vBus.$emit("show-message", "error");
                        this.deleteInAction = false;
                    }.bind(this));
                }.bind(this);
                AtlasHelper.deleteAtlasConfirmation(positiveCallback, this.$vBus, this.atlasData);
            },
            getAtlasData: function () {
                AtlasHelper.getAtlasData(this.atlasId).then(function (data) {
                    this.key += 1;
                    this.atlasData = data;
                    if (this.atlasData.images) {
                        this.atlasImage = this.atlasData.images[this.atlasData.images.length - 1];
                        this.appStyle = {
                            backgroundImage: "url(" + this.getAtlasImageUrl(this.atlasImage["atlasImageID"]) + ")",
                            backgroundSize: "cover",
                            backgroundPosition: "center center"
                        };
                    } else {
                        this.atlasImage = null;
                        this.appStyle = null;
                        /*
                        this.appStyle = {
                            backgroundImage: "url(" + require("@/assets/app/logo/geoportal-blue.png") + ")",
                            backgroundSize: "cover",
                            backgroundPosition: "center center"
                        };
                        */
                    }
                    this.loading = false;
                }.bind(this), function (e) {
                    if (e && e.message == "unauthorized to getAtlas.") { // FIXME! Tikrinimas turi būti pagal kažkokį statuso kodą, o ne pagal teksto reikšmę!
                        this.$router.push("/my-content");
                        this.$vBus.$emit("show-message", "Jūs neturite šio atlaso peržiūros teisių!");
                    }
                    this.loadingError = true;
                    this.loading = false;
                }.bind(this));
            },
            isMineAtlas: function (atlas) {
                return CommonHelper.isMineAtlas(atlas);
            },
            uploadImg: function () {
                this.imgUploadInAction = true;
                AtlasHelper.createImage(this.atlasId, this.img).then(function () {
                    this.imgUploadInAction = false;
                    this.img = null;
                    this.getAtlasData();
                }.bind(this), function () {
                    this.$vBus.$emit("show-message", "error");
                    this.imgUploadInAction = false;
                }.bind(this));
            },
            getAtlasImageUrl: function (atlasImageId) {
                return AtlasHelper.getImageUrl(this.atlasId, atlasImageId);
            },
            deleteImg: function () {
                this.imgDeleteInAction = true;
                AtlasHelper.deleteAtlasImage(this.atlasId, this.atlasImage["atlasImageID"]).then(function () { // TODO, FIXME!..
                    this.imgDeleteInAction = false;
                    this.getAtlasData();
                }.bind(this), function () {
                    this.imgDeleteInAction = false;
                }.bind(this));
            },
            downloadAtlas: function () {
                var url = AtlasHelper.getPrintedAtlasUrl(this.atlasId);
                window.open(url, "_blank");
            }
        }
    };
</script>

<style scoped>

    .atlas-title-bg {
        height: 100%;
        background: #00000050;
        position: relative;
    }

    .atlas-title i {
        color: #ffffff !important;
    }

    .link {
        color: inherit;
        text-decoration: none;
    }

    .v-file-input {
        max-width: 400px;
    }

    .atlas-data {
        background-color: rgba(255, 255, 255, 0.7);
    }

    .atlas-title-upload {
        position: absolute;
        bottom: 0;
        width: 22em;
    }

    .intro-subtitle {
        color: rgba(227, 231, 238);
        font-size: 24px;
        line-height: 1.8em;
        font-weight: 400;
        font-size: 24px;
    }
</style>